import pick from 'ramda/src/pick'
import pickBy from 'ramda/src/pickBy'
import keys from 'ramda/src/keys'
import { EventEmitter } from 'eventemitter3'
const service = (verb, entity = 'Search') => `entity.${entity}/${verb}` // @fixme !
const cond = k => `YesWeChat\\ServiceEntityBundle\\Query\\Condition\\${k}`

export default class Entity extends EventEmitter {
  constructor (data, socket) {
    super()
    this.socket = socket
    this.setData(data)
    this.loading = false
  }

  setData (data) {
    const delta = this.getDelta()
    Object.assign(this, data)
    this.hasUpdate(delta)
    return this
  }

  getDelta (opts, serializers) {
    return JSON.stringify(this.marshall(opts, serializers))
  }

  hasUpdate (delta) {
    if (delta !== this.getDelta()) {
      this.emit('update')
    }
  }

  load () {
    if (!this.loading && this.id) {
      this.loading = this.socket.service(service('READ', this.entityClass), { id: this.id })
        .then(data => {
          this.loading = false

          return data
        })
        .then(this.setData.bind(this))
    }
    return this.loading
  }

  save (fn) {
    if (!this.saving) {
      this.saving = this.socket.service(service('SAVE'), fn ? fn() : this.marshall())
        .then(data => {
          this.saving = false
          return data
        })
        .then(this.setData.bind(this))
        .then(data => {
          this.emit('saved')
          return data
        })
    }
    return this.saving
  }

  marshall (f, serializers = {}) {
    if (!f) {
      f = this.entityFields
    }
    const entities = pickBy(e => e instanceof Entity || (e && e.marshall && typeof e.marshall === 'function'), this)
    const props = keys(entities)
      .filter(e => f.includes(e))
      .reduce((acc, k) => {
        if (k in serializers) {
          acc[k] = serializers[k](entities[k])
        } else {
          acc[k] = entities[k].marshall()
        }
        return acc
      }, pick(f, this))
    return keys(pickBy(e => Array.isArray(e), props))
      .reduce((acc, k) => {
        if (k in serializers) {
          acc[k] = acc[k].map(serializers[k])
          return acc
        }
        acc[k] = acc[k].map(e => {
          if (e instanceof Entity || (e && e.marshall && typeof e.marshall === 'function')) {
            return e.marshall()
          }
          return e
        })
        return acc
      }, props)
  }
}

Entity.getByChatUser = async function (chatUser, socket, Cast) {
  const list = await socket.service(service('QUERY'), {
    alias: 'r',
    class: Entity.entityClass,
    parameters: [
      { type: cond('Parameter'), name: 'chatUser', value: chatUser }
    ],
    conditions: [
      {
        type: cond('Equals'),
        value: 'chatUser',
        subject: {
          type: cond('Field'),
          name: 'r.chatUser'
        }
      }
    ]
  })
  if (list.length === 1) {
    return new Cast(list[0], socket)
  }
}
